<template>
    <v-container fluid class="scroll-y fullscreen" pa-0>
        <v-card
            class="mx-auto"
            flat
            :loading="loading"
            loader-height="10"
            tile
        >
            <v-toolbar
            color="#003a6f"
            dark
            flat
            >
                <v-toolbar-title>{{ pageTitleFull }}</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn
                    color="primary"
                    :to="{ name: 'New User', params: { role: 'cleaner' }}"
                    tile
                    small
                    >
                        <v-icon dark>mdi-plus</v-icon>
                        Add New
                </v-btn>
                <v-btn
                    color="#ffffff"
                    class="primary--text"
                    @click="drawer = !drawer" 
                    tile
                    small
                    v-if="routeKey != 'new'"
                    >
                        Filter
                </v-btn>
            </v-toolbar>
            <v-toolbar
            color="#0c477c"
            dark
            flat
            height="40"
            >
                <v-spacer></v-spacer>
                <v-toolbar-title class="cleaner-count" >
                     {{ total + ' Cleaners Found.' }}
                </v-toolbar-title>
                <v-spacer></v-spacer>
            </v-toolbar>
            <v-list two-line tile flat class="py-0 hover-list">
                <template v-for="(cleaner, index) in cleaners">
                    <v-list-item
                    :key="`cleaner-${index}`"
                    :value="cleaner.id"                 
                    >
                        <template>
                            <v-list-item-content @click.stop="openCleaner(cleaner.id)">
                                <v-list-item-title v-html="cleaner.name"></v-list-item-title>
                            </v-list-item-content>
                            <v-list-item-action>
                                <v-list-item-icon class="ma-0 mb-1">
                                    <v-btn small tile class="mr-1" color="#003a6f" elevation="0" dark @click.stop="dial(cleaner.phone)">
                                        <v-icon dark>mdi-phone</v-icon>
                                    </v-btn>
                                    <v-btn small tile color="primary" elevation="0" dark @click.stop="sendmail(cleaner.email)">
                                        <v-icon dark>mdi-email</v-icon>
                                    </v-btn>
                                </v-list-item-icon>
                            </v-list-item-action>
                        </template>
                    </v-list-item>
                    <v-divider
                    :key="`dv-${index}`"
                    ></v-divider>
                </template>
                <v-list-item v-if="pagination.total > 1">
                    <v-list-item-content>
                        <v-pagination
                            v-model="pagination.current"
                            :length="pagination.total"
                            @input="onPageChange"
                            :total-visible="totalVisible"
                        ></v-pagination>
                    </v-list-item-content>
                </v-list-item>
            </v-list>
        </v-card>
        <FilterDrawer :show="drawer" :filter="filter" :routekey="routeKey" @update-drawer="updateDrawer" @update-keyword="updateKeyword" @submit-search="submitSearch"/>
    </v-container>
</template>

<script>
import axios from 'axios'
import FilterDrawer from '../components/FilterUsers.vue'

export default {
    data() {
        return {
            drawer: false,
            loading: true,
            cleaners: [],
            pagination: {
                current: 1,
                total: 0
            },
            totalVisible: 5,
            pageTitle: '',
            apiUrl: '',
            routeKey: '',
            filter: {
                keyword: "",
            },
            total: 0,
        }
    },
    created() {
        this.pageTitle = this.$route.meta.title
        this.apiUrl = this.$route.meta.api
        this.routeKey = this.$route.meta.key
        this.getCleaners()
    },
    computed: {
        pageTitleFull() {
            if(this.loading == true) {
                return 'Loading...'
            } else {
                return this.pageTitle
            }
        },
    },
    components: {
        FilterDrawer
    },
    methods: {
        getCleaners() {
            this.loading = true
            this.drawer = false
            axios.get(this.apiUrl + this.pagination.current, {
                params: this.filter
            })
            .then(response => {
                this.loading = false
                this.cleaners = response.data.cleaners.data
                this.pagination.current = response.data.cleaners.current_page
                this.pagination.total = response.data.cleaners.last_page
                this.total = response.data.cleaners.total
                this.$nextTick()
            })
        },
        onPageChange() {
            this.getCleaners()
            this.$vuetify.goTo(0)
        },
        openCleaner(id) {
            this.$router.push({ path: '/cleaner/'+id })
        },
        dial (number) {
            window.location ='tel:'+number;
        },
        sendmail (address ){
            window.location = 'mailto:'+address;
        },
        updateDrawer(val) {
            this.drawer = val
        },
        updateKeyword(val) {
            this.filter.keyword = val
        },
        submitSearch() {
            this.getCleaners()
        },
    }
}
</script>
<style lang="sass" scoped>
.theme--light 
    .v-content
        background: #ffffff
.fullscreen
    background: #fff
    height: 100%
.w-100
    width: 100%
    .v-btn 
        width: 100%
.v-list-item__action
    .v-btn
        &:not(.v-btn--round)
            &.v-size--small
                height: 42px
.v-chip 
    border-radius: 0!important
.cleaner-count
    font-size: 14px
</style>